(function(Modal, $, undefined) {

  let timesModalSeen;
  let player
  let videoType

  var triggerNewsletterModal = function() {
    timesModalSeen = getCookie('ss.newsletterModalSeen') || 0
    timesModalSeen = parseInt(timesModalSeen)

    if (timesModalSeen < 1) {
      const inst = $('[data-remodal-id=newsletter]').remodal();
      setTimeout(function() {
        inst.open();
      }, 30000)
    }
  }
  
  var bindUIActions = function() {
    $(document).on('closed', '[data-remodal-id="newsletter"]', function (e) {
      setCookie('ss.newsletterModalSeen', timesModalSeen + 1, 365);
    });

    $(document).on('opened', '[data-video-modal]', function () {
      var iframe = $(this).find('iframe');
      videoType = iframe.attr('src').match('vimeo') ? 'vimeo' : 'youtube'

      if (videoType === 'vimeo') {
        player = new Vimeo.Player(iframe);
        player.ready().then(function() {
          if (window.innerWidth > 1024) {
            player.play();
          }
        });
      } else {
        player = iframe[0].contentWindow
        console.log(player)
        if (window.innerWidth > 1024) {
          player.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }
      }
    });

    $(document).on('closing', '[data-video-modal]', function () {
      if (videoType === 'vimeo') {
        player.unload();
      } else {
        player.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*')
      }
    });
  }

  Modal.init = function() {
    triggerNewsletterModal();
    bindUIActions();
  }

}(window.Modal = window.Modal || {}, jQuery));